<template>
    <custom-table
        :title="$t('pages.company.officer.title')"
        :subTitle="$t('pages.company.officer.subTitle')"
        rowKey="id"
        :items="table.data"
        :loading="table.loading"
        selectableRows
        :columns="fields"
        :actions="actions"
        :pagination="table.pagination"
        filterComponentName="CompanyOfficerFilter"
        changeUrlPage
        @action="handleClickAction"
        @selectableRows="handleSelectedRow"
        @changeTable="handleTableChange">
        <template v-slot:fullName="{ row: record }">
            {{ record.user.firstname + ' ' + record.user.lastname }}
        </template>
        <template v-slot:email="{ row: record }">
            <a :href="'mailto:' + record.user.email" class="text-gray-600 text-hover-primary mb-1">
                {{ record.user.email }}
            </a>
        </template>
        <template v-slot:mobilePhone="{ row: record }">
            <a :href="'tel:' + record.user.mobile_phone" class="text-gray-600 text-hover-primary mb-1">
                {{ record.user.mobile_phone }}
            </a>
        </template>
        <template v-slot:actions="{ row: record }">
            <div class="d-flex justify-content-end">
                <a @click="deleteRecord([record.id])" class="btn btn-icon btn-bg-light btn-active-color-primary btn-sm">
                    <span class="svg-icon svg-icon-3">
                        <inline-svg src="/media/icons/duotune/general/gen027.svg"/>
                    </span>
                </a>
            </div>
        </template>
    </custom-table>

    <div class="modal fade" id="kt_modal_officer" ref="officerModal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered mw-650px">
            <div class="modal-content">
                <div class="modal-header" id="kt_modal_add_customer_header">
                    <h2 class="fw-bolder">{{ form.title }}</h2>
                    <div id="kt_modal_add_customer_close" data-bs-dismiss="modal"
                         class="btn btn-icon btn-sm btn-active-icon-primary">
                        <span class="svg-icon svg-icon-1">
                            <inline-svg src="/media/icons/duotune/arrows/arr061.svg"/>
                        </span>
                    </div>
                </div>
                <el-form @submit.prevent="onSubmit()" :model="form.data" ref="userForm">
                    <div class="modal-body py-10 px-lg-17">
                        <div class="scroll-y me-n7 pe-7" id="kt_modal_add_customer_scroll" data-kt-scroll="true"
                             data-kt-scroll-activate="{default: false, lg: true}" data-kt-scroll-max-height="auto"
                             data-kt-scroll-dependencies="#kt_modal_add_customer_header"
                             data-kt-scroll-wrappers="#kt_modal_add_customer_scroll" data-kt-scroll-offset="300px">
                            <div class="fv-row mb-7">
                                <label class="required fs-6 fw-bold mb-2">{{
                                        $t('pages.company.officer.cols.firstname')
                                    }}</label>
                                <el-form-item prop="user.firstname" :rules="$validation.getMessage(['required'])">
                                    <el-input v-model="form.data.user.firstname" type="text" disabled/>
                                </el-form-item>
                            </div>

                            <div class="fv-row mb-7">
                                <label class="required fs-6 fw-bold mb-2">{{
                                        $t('pages.company.officer.cols.lastname')
                                    }}</label>
                                <el-form-item prop="user.lastname" :rules="$validation.getMessage(['required'])">
                                    <el-input v-model="form.data.user.lastname" type="text" disabled/>
                                </el-form-item>
                            </div>

                            <div class="fv-row mb-7">
                                <label class="required fs-6 fw-bold mb-2">{{
                                        $t('pages.company.officer.cols.email')
                                    }}</label>
                                <el-form-item prop="user.email"
                                              :rules="$validation.getMessage(['requiredBlur', 'email'])">
                                    <el-input v-model="form.data.user.email" autocomplete="off" disabled/>
                                </el-form-item>
                            </div>

                            <div class="fv-row mb-7">
                                <label class="fs-6 fw-bold mb-2">{{
                                        $t('pages.company.officer.cols.mobilePhone')
                                    }}</label>
                                <el-form-item prop="user.mobile_phone">
                                    <el-input v-model="form.data.user.mobile_phone"
                                              v-mask="{ mask:'+999999999999', placeholder: '' }" type="text" disabled/>
                                </el-form-item>
                            </div>

                            <div class="fv-row mb-7">
                                <label class="fs-6 fw-bold mb-2">{{ $t('pages.company.officer.cols.active') }}</label>
                                <el-form-item prop="user.active">
                                    <el-radio-group v-model="form.data.user.active" disabled>
                                        <el-radio-button :label="true">{{ $t("common.active") }}</el-radio-button>
                                        <el-radio-button :label="false">{{ $t("common.passive") }}</el-radio-button>
                                    </el-radio-group>
                                </el-form-item>
                            </div>
                        </div>
                    </div>

                    <div class="modal-footer flex-center">
                        <button :data-kt-indicator="form.loading ? 'on' : null" class="btn btn-lg btn-primary"
                                type="submit" :disabled="true">
                            <span v-if="!form.loading" class="indicator-label">{{ $t("btn.save") }}</span>
                            <span v-if="form.loading" class="indicator-progress">
                                {{ $t("messages.wait") }}
                                <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                            </span>
                        </button>
                    </div>
                </el-form>
            </div>
        </div>
    </div>
    <div class="modal fade" id="kt_modal_add_officer" ref="addOfficerModal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered mw-650px">
            <div class="modal-content">
                <div class="modal-header" id="kt_modal_add_customer_header">
                    <h2 class="fw-bolder">{{ formOfficer.title }}</h2>
                    <div id="kt_modal_add_customer_close" data-bs-dismiss="modal"
                         class="btn btn-icon btn-sm btn-active-icon-primary">
                        <span class="svg-icon svg-icon-1">
                            <inline-svg src="/media/icons/duotune/arrows/arr061.svg"/>
                        </span>
                    </div>
                </div>
                <el-form @submit.prevent="onSubmitAddOfficer()" :model="formOfficer.data" ref="userForm">
                    <div class="modal-body py-10 px-lg-17">
                        <div class="scroll-y me-n7 pe-7" id="kt_modal_add_customer_scroll" data-kt-scroll="true"
                             data-kt-scroll-activate="{default: false, lg: true}" data-kt-scroll-max-height="auto"
                             data-kt-scroll-dependencies="#kt_modal_add_customer_header"
                             data-kt-scroll-wrappers="#kt_modal_add_customer_scroll" data-kt-scroll-offset="300px">
                            <div class="fv-row mb-1">
                                <label class="fs-6 fw-bold mb-2">{{ $t('common.user') }}</label>
                                <el-form-item prop="labels">
                                    <el-select
                                        remote
                                        reserve-keyword
                                        remote-show-suffix
                                        :remote-method="searchUser"
                                        :loading="loading"
                                        v-model="formOfficer.data.user_id" class="w-100"
                                        :placeholder="$t('common.chooseSelect')" filterable>
                                        <el-option v-for="(user, userIndex) in users.data" :key="userIndex"
                                                   :value="user.id" :label="`${user.firstname} ${user.lastname} - ${user.mobile_phone}`"></el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                        </div>
                    </div>

                    <div class="modal-footer flex-center">
                        <button :data-kt-indicator="formOfficer.loading ? 'on' : null" class="btn btn-lg btn-primary"
                                type="submit" :disabled="formOfficer.loading">
                            <span v-if="!formOfficer.loading" class="indicator-label">{{ $t("btn.save") }}</span>
                            <span v-if="formOfficer.loading" class="indicator-progress">
                                {{ $t("messages.wait") }}
                                <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
                            </span>
                        </button>
                    </div>
                </el-form>
            </div>
        </div>
    </div>

</template>

<script>
import CustomTable from "@/components/custom-table";

export default {
    name: "index",
    props: ['companyID', 'showUserBackButton'],
    components: {
        CustomTable
    },
    data() {
        return {
            fields: [
                {
                    name: this.$t("pages.company.officer.cols.id"),
                    key: "id",
                    class: ""
                },
                {
                    name: this.$t("pages.company.officer.cols.fullName"),
                    scopedSlots: {customRender: "fullName"},
                },
                {
                    name: this.$t("pages.company.officer.cols.email"),
                    scopedSlots: {customRender: "email"}
                },
                {
                    name: this.$t("pages.company.officer.cols.mobilePhone"),
                    scopedSlots: {customRender: "mobilePhone"},
                },
                {
                    name: this.$t("common.action"),
                    key: "action",
                    scopedSlots: {customRender: "actions"}
                }
            ],
            actions: [
                {
                    name: "new",
                    icon: "bi-plus-lg",
                    label: "btn.add"
                },
                {
                    name: "refresh",
                    icon: "bi-arrow-repeat",
                    label: "btn.refresh"
                },
                {
                    name: "delete",
                    icon: "bi-trash",
                    label: "btn.delete"
                }
            ],
            form: {
                title: '',
                loading: false,
                updateStatus: false,
                data: {
                    user: {}
                }
            },
            formOfficer: {
                title: '',
                loading: false,
                data: {
                    company_id: undefined,
                    user_id: undefined,
                }
            },
            selectedRowKeys: [],
            filterParameters: {}
        }
    },
    computed: {
        table() {
            return this.$store.state.company.officer.table;
        },
        users() {
            return this.$store.state.user.table;
        }
    },
    mounted() {
        this.filterParameters = {
            sort: 'created_at:desc',
            company_id: this.companyID
        };

        this.$store.dispatch('company/officer/get', {
            page: {
                current: this.$route.query.page
            },
            filterData: Object.assign(this.$root.getFilterWithUrl({}), this.filterParameters)
        });

        this.$store.dispatch('user/get', {
            page: {
                current: this.$route.query.page
            },
        });
    },
    methods: {
        searchUser(query) {
            this.$store.dispatch('user/get', {
                filterData: {magic: query}
            });
        },
        refreshTable() {
            this.filterParameters = {
                sort: 'created_at:desc',
                company_id: this.companyID
            };

            this.$store.dispatch('company/officer/get', {
                page: {
                    current: this.$route.query.page
                },
                filterData: Object.assign(this.$root.getFilterWithUrl({}), this.filterParameters)
            });
        },
        deleteRecord(id) {
            this.eventBus.$emit('showConfirmDialog', {
                title: this.$t('btn.delete'),
                message: this.$t('messages.sureDelete'),
                confirmType: 'danger',
                onConfirm: () => {
                    this.$store.dispatch("company/officer/delete", {id}).then((successDeleted) => {
                        this.selectedRowKeys = this.selectedRowKeys.filter(x => !successDeleted.includes(x));
                        this.refreshTable();
                    });
                },
            });
        },
        handleClickAction(name) {
            switch (name) {
                case "new":
                    this.formOfficer.title = this.$t("pages.company.officer.newOfficer");
                    this.formOfficer.data.company_id = this.companyID;
                    this.showModal(this.$refs.addOfficerModal);
                    break;

                case "refresh":
                    this.refreshTable();
                    break;

                case "delete":
                    this.deleteRecord(this.selectedRowKeys.flat());
                    break;

                default:
                    break;
            }
        },
        handleTableChange(pagination, filterData) {
            this.filterParameters = Object.assign({
                sort: 'created_at:desc',
                user_id: this.companyID
            }, filterData);

            this.$store.dispatch("company/officer/get", {
                page: pagination,
                filterData: this.filterParameters
            });
        },
        handleSelectedRow(record) {
            this.selectedRowKeys = record;
        },
        fetchOfficer(record) {
            this.form.updateStatus = true;
            this.form.currentForm = 'userForm';
            this.form.title = this.$t("pages.ecommerce.user.editUser")
            this.axios.get(this.endpoints['company_officer'] + '/' + record.id).then(response => {
                this.form.data = response.data.data;
                this.showModal(this.$refs.officerModal);
            });
        },

        onSubmit() {
            console.log(this.form);
        },
        onSubmitAddOfficer() {
            this.axios.post(this.endpoints['company_officer'], this.formOfficer.data).then(response => {
                this.onResponse(response.data, () => {
                    this.refreshTable();
                    this.hideModal(this.$refs.addOfficerModal);
                    this.formOfficer.data.user_id = undefined;
                }, () => {
                    this.form.loading = false;
                });
            }).catch(error => {
                this.onResponseFailure(error.response.data, () => {
                    this.form.loading = false;
                });
            });
        },
    }
}
</script>

<style>
.order-page-header:after {
    content: "";
    clear: both;
    display: table;
}
</style>